import {Type} from 'main.core';
import {Node} from 'landing.node';

export class Icon extends Node
{
	constructor()
	{
		super();
	}

	setName()
	{
	}
}